// extracted by mini-css-extract-plugin
export default {"header":"reports_header__C3-mH","btnText":"reports_btnText__hCaVF","linkStyle":"reports_linkStyle__2Z-O7","linkStyleNoPermission":"reports_linkStyleNoPermission__HZA5l"};